import { AImage } from '../AImage/AImage.components';
import { xCloseIconWhite } from 'utils/assets';
import './Tooltip.scss';
import { useEffect, useRef, useState } from 'react';
import { Portal } from 'components/organisms/SalaryOptions/common/Portal';

interface IProps {
  icon: JSX.Element[] | JSX.Element;
  text: string;
  variant?: 'white' | 'purple';
  additionalText?: string;
  mobile?: boolean;
  onClose?: () => void;
}

export const Tooltip = ({ 
  icon, 
  text, 
  variant = 'white', 
  additionalText, 
  mobile = false,
  onClose,
 }: IProps) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const formattedText = text.replace(/,/g, ',<br/>');
  const tooltipText =
    variant === 'white'
      ? `${additionalText ? additionalText : ''} ${formattedText}`
      : formattedText;
    
  const handleIconClick = () => {
    if (mobile) {
      setIsTooltipVisible(true);
    }
  };
  
  const handleClose = (e: React.MouseEvent) => {
    if (mobile) {
      e.stopPropagation();
      setIsTooltipVisible(false);
      if (onClose) onClose();
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  
  if (mobile) {
    return (
      <>
        <div
          className="tooltip__container--mobile"
          role="tooltip"
          data-testid="tooltip__container--mobile"
          onClick={handleIconClick}
        >
          {icon}
        </div>
        {isTooltipVisible && (
          <Portal>
            <>
              <div
                className="tooltip-mobile-overlay"
                onClick={handleOverlayClick}
              />
              <div
                className={`tooltip-mobile tooltip-mobile--${variant}`}
                style={{ '--scale': isTooltipVisible ? 1 : 0 } as React.CSSProperties}
              >
                <div
                  className="tooltip-mobile__close"
                  onClick={handleClose}
                  data-testid="closeIconContainer"
                >
                  <AImage alt="Cerrar modal" url={xCloseIconWhite} />
                </div>
                <div
                  className="tooltip-mobile__content"
                  dangerouslySetInnerHTML={{ __html: tooltipText }}
                />
              </div>
            </>
          </Portal>
        )}
      </>
    );
  }

  return (
    <div
      className="tooltip__container"
      role="tooltip"
      data-testid="tooltip__container"
    >
      {icon}
      <div
        className={`tooltip__text tooltip__text--${variant}`}
        dangerouslySetInnerHTML={{ __html: tooltipText }}
      />
    </div>
  );
};
